document.addEventListener('DOMContentLoaded', () => {
	const loadMoreBtn = document.querySelector('.js-load-more-projects') as HTMLButtonElement | null;
	const list = document.querySelector('.teaser-products__grid');
	const filterSelect = document.querySelector('#projectfilter') as HTMLSelectElement | null;
	const lang = document.documentElement.getAttribute("lang");

	// Wenn modul nicht vorhanden
	if (!loadMoreBtn || !list || !filterSelect) {
		return;
	}

	// Initial Anzahl
	const limit = 9;

	async function loadProjects(offset = 0, append = false) {
		const filterValue = filterSelect.value;
		const filter = filterValue.toLowerCase().replace(/\s+/g, '');
		const response = await fetch(`/ajax/projects?offset=${offset}&limit=${append ? 6 : limit}&clang=${lang}&filter=${filter}`);
		if (!response.ok) {
			console.error('Fehler beim Laden der Projekte.');
			return;
		}

		const data = await response.json();

		// Nachricht anzeigen, wenn keine Ergebnisse gefunden wurden
		if (offset === 0 && data.length === 0) {
			list.innerHTML = '<li class="teaser-products__item no-results">Keine Ergebnisse gefunden.</li>';
			loadMoreBtn.style.display = 'none';
			return;
		}

		// Liste leeren für den Neuaufbau
		if (!append) {
			list.innerHTML = '';
		}

		// Liste aufbauen
		data.forEach((project) => {
			const li = document.createElement('li');
			li.className = 'teaser-products__item grid__item grid__item--8 sm:grid__item--4';
			li.dataset.systemFilter = project.systems;

			const systemsArray = project.systems.split(',').filter((s) => s.trim() !== '');
			const systemsLabel = systemsArray.length === 1 ? 'System' : 'Systeme';

			li.innerHTML = `
                <a href="${project.url}" class="teaser-products__link-wrapper">
                    <figure class="teaser-products__figure">
                        <div class="teaser-products__image">
                            <img src="index.php?rex_media_type=project_preview&amp;rex_media_file=${project.image}" alt="${project.name}" />
                        </div>
                        <figcaption class="teaser-products__caption">
                            <p class="teaser-products__overline">${systemsLabel} ${project.systems}</p>
                            <div class="teaser-products__title-row">
                                <h3 class="teaser-products__title">${project.name}</h3>
                                <span class="icn icn--arrow-up-right" aria-hidden="true"></span>
                            </div>
                        </figcaption>
                    </figure>
                </a>
            `;
			list.appendChild(li);
		});

		// Offset in data-Attribut aktualisieren
		loadMoreBtn.dataset.offset = parseInt(offset) + data.length;

		// Button ausblenden, wenn keine weiteren Elemente geladen werden können
		if (data.length <= 1) {
			loadMoreBtn.style.display = 'none';
		} else {
			loadMoreBtn.style.display = '';
		}
	}

	// Seite initial laden
	loadProjects(0, false);

	// Mehr laden Handler
	loadMoreBtn.addEventListener('click', () => {
		const offset = parseInt(loadMoreBtn.dataset.offset);
		loadProjects(offset, true);
	});

	// Reload bei Filterwechsel
	filterSelect.addEventListener('change', () => {
		loadMoreBtn.dataset.offset = 0;
		loadProjects(0, false);
	});
});
